import React, { Component, Fragment } from 'react';
import { Card, CardBody, Row, Col, Button } from 'reactstrap';

class ClinicSpeechTerapyText extends Component {
    constructor(props) {
        super(props);
    }

    

    componentDidMount(){
        //this.transferToHtml(this.props.audiometria.fonoaudiologia)
    }

    transferToHtml = (resul) => {
       // document.getElementById("demo").innerHTML=resul;
       //Reemplaza las etiquetas <p> por <div> del CKE Editor
		/* let splitted = informe.rows[0].fonoaudiologia.split('</p>');
		let finalHTML = "";
		for (let i = 0; i < splitted.length; i++) {
			if (splitted[i] != "") {
				if(splitted[i].includes('<p>')) //Cambia las Etiquetas de Parrafo
				{
					finalHTML = finalHTML + splitted[i].replace('<p>', '<div>') + '</div>';
				}
				if(splitted[i].includes('</ul>'))//Cambia las etiquetas de Guiones
				{
					let htmlUl = splitted[i].replace('<ul>', '<div>');
					htmlUl = htmlUl.replace('</ul>', '</div>');
					let splittedLi = htmlUl.split('<li>');
					let finalSplittedText = "";
					for(let li = 0; li < splittedLi.length; li++)
					{
						if(splittedLi[li] != "<div>")
						{
							splittedLi[li] = "-&nbsp;" + splittedLi[li];
							splittedLi[li] = splittedLi[li].replace('</li>','&nbsp;');
						}
						finalSplittedText = finalSplittedText + splittedLi[li];
					}
					finalHTML = finalHTML + finalSplittedText;
				}
			}
		}

		
		if(finalHTML == "")
		{
			informe.rows[0].fonoaudiologia = '<div>' + informe.rows[0].fonoaudiologia + '</div>';	
		}
		else
		{
			informe.rows[0].fonoaudiologia = finalHTML;
		} */
    }

    createMarkUp = ()=>{
        return {_html: `${this.props.audiometria.fonoaudiologia}`}
    }

    render() {
        const fonoaudiologia = `${this.props.audiometria.fonoaudiologia}`;
        //var d1 =  document.getElementById('one');
        //d1.insertAdjacentHTML('afterend',this.props.audiometria.fonoaudiologia);
        return (
            <>
                <Fragment>
                    {this.props.audiometria.fonoaudiologia != null ?
                        <Fragment>
                            <h4 style={{ marginTop: 20, marginBottom: 10 }} >Audiometria</h4>
                            <hr />
                            <Row style={{ marginTop: 10 }}>
                                {/* <p style={{whiteSpace: 'pre-line'}}>{this.props.audiometria.fonoaudiologia}</p> */}
                                {/* <div style={{whiteSpace: 'pre-line'}}>{this.props.audiometria.fonoaudiologia}</div> */}
                               {/*  <pre style={{whiteSpace: 'pre-line'}}><p>{this.props.audiometria.fonoaudiologia}</p></pre> */}
                                {/* <pre><p> {fonoaudiologia}</p></pre> */}
                                {/* <p className='demo'></p> */}
                                {/* <pre>{content}</pre> */}
                                {/* <div dangerouslySetInnerHTML={this.createMarkUp()}></div> */}
                                <div dangerouslySetInnerHTML={{ __html: this.props.audiometria.fonoaudiologia }} />


                            </Row>
                        </Fragment>
                        : null
                    }
                </Fragment>
            </>
        );
    }
}

export default ClinicSpeechTerapyText;
